import image1 from '../../../../assets/images/work/fiar/FiAR_detailed_img1.webp';
import image2 from '../../../../assets/images/work/fiar/FiAR_detailed_img2.webp';
import image4 from '../../../../assets/images/work/fiar/FiAR_detailed_abovefooter.webp';

import artwork from '../../../../assets/images/art_2.png';

const Data_FiAR = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Fire extinguisher training often relies on live-fire exercises that can be costly, difficult to
                      coordinate, and inherently risky. As organizations increasingly move away from traditional live-fire
                      scenarios, many training programs struggle to maintain realism and learner engagement while still
                      teaching the critical decision-making required in real emergencies.
                      <br />
                      <br />
                      FiAR was created to modernize fire safety training by delivering a realistic, hands-on experience
                      without placing learners in harm's way-while keeping the training portable, repeatable, and easier to
                      deploy in more settings.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The core challenge was delivering "true-to-life" fire training in a way that feels authentic and
                      intuitive, while working across different environments and audiences. FiAR needed to accurately
                      simulate realistic fire scenarios, reinforce correct extinguisher selection and technique, and pair
                      augmented reality with specialized hardware to create a convincing, repeatable training experience.
                      <br />
                      <br />
                      Throughout development, feedback and validation from industry experts were essential to ensuring the
                      experience was both credible and effective for real-world training needs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    The world's first AR fire extinguisher training tool-bringing realism and engagement to modern fire
                    safety training.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      FiAR is NORCAT's augmented reality fire extinguisher training tool that delivers a new level of
                      realism and learner engagement. Built to address an industry with limited innovation over the last
                      decade, FiAR uses augmented reality technologies paired with patented hardware to create a safe,
                      immersive training experience.
                      <br />
                      <br />
                      Learners train hands-on without live flames or exposure to risk, while still practicing the
                      decision-making and actions required in real emergency situations-making the experience repeatable,
                      scalable, and easier to deliver consistently.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Built with Expert Feedback</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      To ensure realism and training value, FiAR was shaped through ongoing feedback from industry experts,
                      including fire chiefs, firefighters, fire safety representatives, trainers, and members of the public.
                      This iterative approach helped refine the experience into a reliable and effective training tool
                      designed to keep learners engaged while reinforcing correct technique.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="FiAR project screenshot 7" loading="lazy" decoding="async" />
            </div>
            <div className="single-image">
              <img src={image2} alt="FiAR project screenshot 8" loading="lazy" decoding="async" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Innovation & Engagement</h2>

                  <div className="paragraph dark-1">
                    <p>
                      FiAR was designed to make fire safety training more practical to deliver-without sacrificing realism.
                      With a full, portable product package, trainers can bring immersive fire extinguisher scenarios to
                      workplaces, classrooms, and community environments. The experience supports meaningful training for
                      corporate teams, managers, landlords and tenants, and youth learners-from elementary through high
                      school-helping build stronger safety awareness across audiences.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>Augmented reality scenarios that increase realism and presence</li>
                      <li>Patented hardware designed to support authentic training interactions</li>
                      <li>Repeatable training without live-fire risk or complex setup</li>
                      <li>Portable format built to deliver training in virtually any environment</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="FiAR project screenshot 9" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      FiAR enables organizations to deliver a realistic fire extinguisher training experience without live
                      fire-supporting the industry shift away from traditional burn-based exercises. By combining AR and
                      purpose-built hardware, the training can be delivered more consistently, more safely, and with higher
                      learner engagement.
                      <br />
                      <br />
                      Designed to be portable and adaptable, FiAR fits the need for "true-to-life" fire extinguishing
                      practice in a wide range of environments. The result is a repeatable training tool that helps learners
                      build confidence, practice correct technique, and retain critical fire safety knowledge.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                   <div className="paragraph light-1">
                      <p>Commercialized Product</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>NORCAT (Internal)</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">WEBSITE</h4>
                    <div className="paragraph light-1">
                      <p> <a href="https://fi-ar.com" target="_blank" rel="noopener noreferrer">
    www.fi-ar.com
  </a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let's explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2" aria-hidden="true">
            <img src={artwork} alt="" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_FiAR;


